import React from "react";
import { AILogoIcon, LabsIcon, XIcon, DownloadIconNew } from "../../../assets/images/svg";
import Button from "../../../components/form/button/button";
import AILoader from "./AILoader";

const AIHeader = ({ isOpen, setIsOpen, showLoader, exportDetails, errors }) => {
  const showDownload = exportDetails && !errors;
  const showClose = setIsOpen && isOpen;
  const showInsights = setIsOpen && !isOpen;

  return (
    <div className="ai__header">
      <div className="ai__header-logo">
        <AILogoIcon className="ai-logo-icon" data-testid="ai-logo" />
        <span>ChaseIQ</span>
        <span className="ai__badge">
          <LabsIcon /> <span>Labs</span>
        </span>
        {showLoader && !isOpen && <AILoader textOnly />}
      </div>

      {(showDownload || showClose) && (
        <div className="ai__header-actions">
          {showDownload && (
            <button
              data-testid="export-pdf-button"
              className="button button--secondary button--no-outline"
              onClick={exportDetails.exportPdf}
              disabled={exportDetails.pdfLoading}
            >
              <DownloadIconNew width={16} height={16} />
            </button>
          )}
          {showClose && (
            <button
              className="button button--secondary button--no-outline"
              onClick={() => setIsOpen(false)}
              type="button"
              data-testid="close-button"
            >
              <XIcon />
            </button>
          )}
        </div>
      )}

      {showInsights && (
        <Button
          customClassName="show-button"
          text="Show insights"
          onClick={() => setIsOpen(true)}
        />
      )}
    </div>
  );
};

export default AIHeader;
